import { Injectable } from '@angular/core';

export enum InspectionResult {
  Pass = 'pass',
  Fail = 'fail',
}

@Injectable()
export class InspectionFormService {
  present(url: string): Promise<InspectionResult> {
    return new Promise((resolve, reject) => {
      const popup = window.open(url, '_blank');
      if (!popup) {
        reject('Unable to open the inspection form.');
        return;
      }

      let status: InspectionResult;
      let eventUrl = url;
      const intervalId = window.setInterval(() => {
        if (popup.closed) {
          window.clearInterval(intervalId);
          if (!status) {
            reject(
              'Complete the inspection in the new tab, then return and finish the order manually.'
            );
          }
          return;
        }

        try {
          eventUrl = popup.location.href || eventUrl;
          if (eventUrl.includes('status=')) {
            status = this.getStatusFromUrl(eventUrl);
            if (status) {
              window.clearInterval(intervalId);
              popup.close();
              resolve(status);
            }
          }
        } catch (error) {
          // Ignore cross-origin reads until the popup reaches a readable URL.
        }
      }, 500);
    });
  }

  private getStatusFromUrl(url: string): InspectionResult | null {
    const STATUS_REGEX = /status=(.+)/;
    const queryString = (url || '').split('?').pop() || '';
    const match = queryString.match(STATUS_REGEX);
    return match ? (match[1] as InspectionResult) : null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-detail/components/order-detail-tasks-list/inspection-form.service.ts